import React from 'react';
import moment from 'moment';

export const DashboardDateContext = React.createContext({
  date: moment(),
  setDate: () => {},
});
